<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <div *ngIf="toggle.checked && viewType !== 'table'">
    <div class="d-flex gap-3 flex-wrap">
      <ng-container *ngIf="delayed">
        <app-notify-automation-delayed
          [ctrl]="form.get('delayed')"
          [showLabel]="false"
          [disabled]="isEditing$ | async"
        ></app-notify-automation-delayed>
      </ng-container>
      <ng-container>
        <app-user-select
          [ctrl]="form.get('users')"
          placeholder="Select Users"
          [showLabel]="false"
          [disabled]="isEditing$ | async"
        ></app-user-select>
      </ng-container>
      <ng-container *ngIf="template">
        <button class="btn btn-secondary-info" (click)="info.onEditTemplate()" [disabled]="isEditing$ | async">
          <i class="cs-icon cs-icon-pencil"></i>
          <ng-container i18n>Template</ng-container>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [template]="template"
  [class.d-none]="viewType !== 'table'"
  #info
></app-autopilot-automation-info>
